<template>
  <div>
    <div v-if="$store.state.examInfo && examAllow == true">
      <div v-if="$store.state.examInfo.answer_pre_remain_time">
        <CRow v-if="$store.state.examInfo.answer_pre_subject == 'CS'">
          <CCol
            lg="12"
            class="bg-info text-center"
            style="padding: 20px; margin-bottom: 20px"
            v-if="$store.state.examInfo.answer_pre_current_item <= 10"
          >
            <table>
              <tr>
                <td width="50%">
                  ข้อที่: {{ $store.state.examInfo.answer_pre_current_item }}/10
                </td>
                <td width="50%">
                  เหลือเวลา:
                  {{ $store.state.examInfo.answer_pre_remain_time }} นาที
                </td>
              </tr>
            </table>
          </CCol>
          <CRow v-else class="alert alert-success"
            >ทดสอบก่อนอบรมเสร็จแล้วโปรดกลับ ไปยัง Dashboard</CRow
          >
          <CCol
            lg="12"
            v-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1A'
            "
          >
            <PreCS1A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1B'
            "
          >
            <PreCS1B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1C'
            "
          >
            <PreCS1C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1D'
            "
          >
            <PreCS1D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1E'
            "
          >
            ข้อ 1
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2A'
            "
          >
            <PreCS2A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2B'
            "
          >
            <PreCS2B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2C'
            "
          >
            <PreCS2C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2D'
            "
          >
            <PreCS2D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2E'
            "
          >
            ข้อ 2
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3A'
            "
          >
            <PreCS3A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3B'
            "
          >
            <PreCS3B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3C'
            "
          >
            <PreCS3C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3D'
            "
          >
            <PreCS3D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3E'
            "
          >
            ข้อ 3
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4A'
            "
          >
            <PreCS4A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4B'
            "
          >
            <PreCS4B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4C'
            "
          >
            <PreCS4C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4D'
            "
          >
            <PreCS4D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4E'
            "
          >
            ข้อ 4
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5A'
            "
          >
            <PreCS5A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5B'
            "
          >
            <PreCS5B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5C'
            "
          >
            <PreCS5C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5D'
            "
          >
            <PreCS5D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5E'
            "
          >
            ข้อ 5
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6A'
            "
          >
            <PreCS6A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6B'
            "
          >
            <PreCS6B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6C'
            "
          >
            <PreCS6C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6D'
            "
          >
            <PreCS6D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6E'
            "
          >
            ข้อ 6
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7A'
            "
          >
            <PreCS7A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7B'
            "
          >
            <PreCS7B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7C'
            "
          >
            <PreCS7C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7D'
            "
          >
            <PreCS7D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7E'
            "
          >
            ข้อ 7
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8A'
            "
          >
            <PreCS8A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8B'
            "
          >
            <PreCS8B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8C'
            "
          >
            <PreCS8C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8D'
            "
          >
            <PreCS8D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8E'
            "
          >
            ข้อ 8
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9A'
            "
          >
            <PreCS9A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9B'
            "
          >
            <PreCS9B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9C'
            "
          >
            <PreCS9C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9D'
            "
          >
            <PreCS9D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9E'
            "
          >
            ข้อ 9
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10A'
            "
          >
            <PreCS10A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10B'
            "
          >
            <PreCS10B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10C'
            "
          >
            <PreCS10C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10D'
            "
          >
            <PreCS10D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10E'
            "
          >
            ข้อ 10
          </CCol>
        </CRow>
        <CRow v-else-if="$store.state.examInfo.answer_pre_subject == 'MA'">
          <CCol
            lg="12"
            class="bg-warning text-center"
            style="padding: 20px; margin-bottom: 20px"
            v-if="$store.state.examInfo.answer_pre_current_item <= 10"
          >
            <table>
              <tr>
                <td width="50%">
                  ข้อที่: {{ $store.state.examInfo.answer_pre_current_item }}/10
                </td>
                <td width="50%">
                  เหลือเวลา:
                  {{ $store.state.examInfo.answer_pre_remain_time }} นาที
                </td>
              </tr>
            </table>
          </CCol>
          <CRow v-else class="alert alert-success"
            >ทดสอบก่อนอบรมเสร็จแล้วโปรดกลับ ไปยัง Dashboard</CRow
          >
          <CCol
            lg="12"
            v-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1A'
            "
          >
            <PreMA1A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1B'
            "
          >
            <PreMA1B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1C'
            "
          >
            <PreMA1C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1D'
            "
          >
            <PreMA1D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1E'
            "
          >
            ข้อ 1
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2A'
            "
          >
            <PreMA2A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2B'
            "
          >
            <PreMA2B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2C'
            "
          >
            <PreMA2C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2D'
            "
          >
            <PreMA2D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2E'
            "
          >
            ข้อ 2
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3A'
            "
          >
            <PreMA3A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3B'
            "
          >
            <PreMA3B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3C'
            "
          >
            <PreMA3C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3D'
            "
          >
            <PreMA3D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3E'
            "
          >
            ข้อ 3
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4A'
            "
          >
            <PreMA4A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4B'
            "
          >
            <PreMA4B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4C'
            "
          >
            <PreMA4C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4D'
            "
          >
            <PreMA4D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4E'
            "
          >
            ข้อ 4
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5A'
            "
          >
            <PreMA5A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5B'
            "
          >
            <PreMA5B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5C'
            "
          >
            <PreMA5C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5D'
            "
          >
            <PreMA5D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5E'
            "
          >
            ข้อ 5
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6A'
            "
          >
            <PreMA6A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6B'
            "
          >
            <PreMA6B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6C'
            "
          >
            <PreMA6C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6D'
            "
          >
            <PreMA6D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6E'
            "
          >
            ข้อ 6
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7A'
            "
          >
            <PreMA7A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7B'
            "
          >
            <PreMA7B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7C'
            "
          >
            <PreMA7C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7D'
            "
          >
            <PreMA7D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7E'
            "
          >
            ข้อ 7
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8A'
            "
          >
            <PreMA8A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8B'
            "
          >
            <PreMA8B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8C'
            "
          >
            <PreMA8C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8D'
            "
          >
            <PreMA8D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8E'
            "
          >
            ข้อ 8
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9A'
            "
          >
            <PreMA9A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9B'
            "
          >
            <PreMA9B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9C'
            "
          >
            <PreMA9C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9D'
            "
          >
            <PreMA9D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9E'
            "
          >
            ข้อ 9
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10A'
            "
          >
            <PreMA10A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10B'
            "
          >
            <PreMA10B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10C'
            "
          >
            <PreMA10C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10D'
            "
          >
            <PreMA10D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10E'
            "
          >
            ข้อ 10
          </CCol>
        </CRow>
        <CRow v-else-if="$store.state.examInfo.answer_pre_subject == 'SC'">
          <CCol
            lg="12"
            class="bg-success text-center"
            style="padding: 20px; margin-bottom: 20px"
            v-if="$store.state.examInfo.answer_pre_current_item <= 10"
          >
            <table>
              <tr>
                <td width="50%">
                  ข้อที่: {{ $store.state.examInfo.answer_pre_current_item }}/10
                </td>
                <td width="50%">
                  เหลือเวลา:
                  {{ $store.state.examInfo.answer_pre_remain_time }} นาที
                </td>
              </tr>
            </table>
          </CCol>
          <CRow v-else class="alert alert-success"
            >ทดสอบก่อนอบรมเสร็จแล้วโปรดกลับ ไปยัง Dashboard</CRow
          >
          <CCol
            lg="12"
            v-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1A'
            "
          >
            <PreSC1A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1B'
            "
          >
            <PreSC1B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1C'
            "
          >
            <PreSC1C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1D'
            "
          >
            <PreSC1D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '1E'
            "
          >
            ข้อ 1
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2A'
            "
          >
            <PreSC2A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2B'
            "
          >
            <PreSC2B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2C'
            "
          >
            <PreSC2C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2D'
            "
          >
            <PreSC2D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '2E'
            "
          >
            ข้อ 2
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3A'
            "
          >
            <PreSC3A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3B'
            "
          >
            <PreSC3B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3C'
            "
          >
            <PreSC3C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3D'
            "
          >
            <PreSC3D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '3E'
            "
          >
            ข้อ 3
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4A'
            "
          >
            <PreSC4A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4B'
            "
          >
            <PreSC4B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4C'
            "
          >
            <PreSC4C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4D'
            "
          >
            <PreSC4D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '4E'
            "
          >
            ข้อ 4
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5A'
            "
          >
            <PreSC5A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5B'
            "
          >
            <PreSC5B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5C'
            "
          >
            <PreSC5C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5D'
            "
          >
            <PreSC5D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '5E'
            "
          >
            ข้อ 5
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6A'
            "
          >
            <PreSC6A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6B'
            "
          >
            <PreSC6B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6C'
            "
          >
            <PreSC6C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6D'
            "
          >
            <PreSC6D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '6E'
            "
          >
            ข้อ 6
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7A'
            "
          >
            <PreSC7A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7B'
            "
          >
            <PreSC7B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7C'
            "
          >
            <PreSC7C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7D'
            "
          >
            <PreSC7D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '7E'
            "
          >
            ข้อ 7
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8A'
            "
          >
            <PreSC8A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8B'
            "
          >
            <PreSC8B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8C'
            "
          >
            <PreSC8C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8D'
            "
          >
            <PreSC8D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '8E'
            "
          >
            ข้อ 8
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9A'
            "
          >
            <PreSC9A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9B'
            "
          >
            <PreSC9B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9C'
            "
          >
            <PreSC9C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9D'
            "
          >

          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '9E'
            "
          >
            ข้อ 9
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10A'
            "
          >
            <PreSC10A />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10B'
            "
          >
            <PreSC10B />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10C'
            "
          >
            <PreSC10C />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10D'
            "
          >
            <PreSC10D />
          </CCol>
          <CCol
            lg="12"
            v-else-if="
              itemList[$store.state.examInfo.answer_pre_current_item - 1] ==
              '10E'
            "
          >
            ข้อ 10
          </CCol>
        </CRow>
      </div>
      <div v-else class="alert alert-danger">หมดเวลาทำแบบทดสอบ</div>
    </div>
    <div v-else class="alert alert-danger">
      อนุญาตให้ทำแบบทดสอบได้เมื่อ {{ examStart }} ถึง {{ examEnd }}
      <h1>ห้ามเปิดต่างนี้ทิ้งไว้</h1>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import XLSX from "xlsx"; // import xlsx
import Table from "./base/Table.vue";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {
    VueGoodTable,
    Datepicker,
    vSelect,
    XLSX,
  },
  data() {
    return {
      responseContent: null,
      darkModal: false,
      userData: this.$cookies.get("user"),
      testInfo: null,
      itemList: null,
      examAllow: false,
      examStart: null,
      examEnd: null,
    };
  },
  created() {
    /*
    setInterval(() => {
      this.updateTime();
    }, 60000);
    */
  },
  mounted() {
    //TEST TYPE IS NOT NULL
    if (this.$store.state.testType == null) {
      alert("!!เข้าถึงแบบทดสอบแบบผิดปกติ!!");
      alert(this.$store.state.testType);
      this.$router.push({ name: "Dashboard" });
    }
    //FETCH TEST DATA
    this.axios
      .get(
        this.$hostUrl +
          "php_action/examAPI2021.php?txtAction=get&userId=" +
          this.userData.adminlogin_id +
          "&subject=" +
          this.$route.params.subjectId +
          "&testType=pretest"
      )
      .then((response) => {
        //console.log(response.data);
        this.testInfo = response.data.mainData;

        let objItem = this.testInfo.items;
        this.itemList = [
          objItem.item1,
          objItem.item2,
          objItem.item3,
          objItem.item4,
          objItem.item5,
          objItem.item6,
          objItem.item7,
          objItem.item8,
          objItem.item9,
          objItem.item10,
        ];
        //COMMIT STORE NEW DATA
        this.$store.commit("setExamInfo", response.data.mainData);
        //console.log(this.$store.state.examInfo);

        //COMPARE DATE-----------------------------------------------------------
        console.log(this.$store.state.examInfo.course_start);
        let courseStart = new Date(this.$store.state.examInfo.course_start);
        //MINUS DAYS
        courseStart.setDate(courseStart.getDate() - 2);
        //SET HOURSE
        courseStart.setHours(0,0,1);
        this.examStart =
          new Date(courseStart).toLocaleDateString() +
          " " +
          new Date(courseStart).toLocaleTimeString();
        console.log("exam start: " + courseStart);

        let courseEnd = new Date(this.$store.state.examInfo.course_start);
        //SET HOURSE
        courseEnd.setHours(23,59,0);
        //console.log(courseEnd);

        this.examEnd =
          new Date(courseEnd).toLocaleDateString() +
          " " +
          new Date(courseEnd).toLocaleTimeString();
        console.log("exam end: " + courseEnd);

        let nD = new Date();
        console.log('now: '+nD);

        if (nD >= courseStart && nD < courseEnd) {
          this.examAllow = true;
        } else {
          this.examAllow = false;
        }
        console.log('exam permission: '+this.examAllow);
        
        //console.log(this.$store.state.examInfo.answer_pre_id);

/*
        var currentD = new Date();
        var startHappyHourD = new Date();
        startHappyHourD.setHours(17, 30, 0); // 5.30 pm
        var endHappyHourD = new Date();
        endHappyHourD.setHours(18, 30, 0); // 6.30 pm
        console.log("happy hour?");
        console.log('happy Start: '+ startHappyHourD);
        console.log('happy End: '+ endHappyHourD);
        if (currentD >= startHappyHourD && currentD < endHappyHourD) {
          console.log("yes!");
        } else {
          console.log("no, sorry! between 5.30pm and 6.30pm");
        }
        */


      })
      .finally(() => {});
  },
  methods: {
    removeAtt(value) {
      var r = confirm("แน่ใจว่าต้องการลบข้อมูล?");
      if (r == true) {
        //SEND DATA
        this.axios
          .get(
            this.$hostUrl +
              "php_action/attendanceAPI.php?txtAction=delete&attId=" +
              value
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.error == false) {
              this.responseContent = response.data.error;
              location.reload();
            } else {
              this.responseContent = response.data.error;
              alert(this.responseContent);
            }
          })
          .finally(() => {});
      } else {
        return true;
      }
    },
    onExport() {
      const dataWS = XLSX.utils.json_to_sheet(this.rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export.xlsx");
    },
    updateTime() {
      //alert("เวลากำลังนับถอยหลัง");
      //SEND DATA TO UPDATE
      this.axios
        .get(
          this.$hostUrl +
            "php_action/examAPI2021.php?txtAction=updateTime&qPretestId=" +
            this.$store.state.examInfo.answer_pre_id
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.error == false) {
            this.responseContent = response.data.error;
            this.$store.commit("setExamInfo", response.data.mainData);
            //location.reload();
          } else {
            this.responseContent = response.data.error;
            alert(this.responseContent);
          }
        })
        .finally(() => {});
    },
  },
};
</script>
